import React, { useState, useEffect, createContext, useMemo } from 'react'
import {IntlProvider} from 'react-intl';
import { SiteLangs } from '../types/enums';
import { useCookies } from 'react-cookie';

import langEn from './en';
import langEs from './es';
import langZh from './zh';
import langPt from './pt';

export interface I18NContextType {
  lang: SiteLangs,
  changeLang: (lang: SiteLangs) => void;
}

export const I18NContext = createContext<I18NContextType>({
  lang: SiteLangs.EN,
  changeLang: () => {}
});

export type I18NProviderProps = {
  children: React.ReactNode
};

const I18NProvider: React.FC<I18NProviderProps> = ({
  children
}) => {
  const [lang, setLang] = useState<SiteLangs>(SiteLangs.ES);
  const [cookies, setCookie] = useCookies(['lang']);

  const changeLang = (lang: SiteLangs) => {
    setCookie('lang', lang);
    setLang(lang);
  }

  const messages = useMemo(() => {
    switch(lang) {
      case SiteLangs.EN:
        return langEn;
      case SiteLangs.ES:
        return langEs;
      case SiteLangs.ZH:
        return langZh;
      case SiteLangs.PT:
        return langPt;
      default:
        return langEn;
    }
  }, [lang])

  useEffect(() => {
    if(window && window.navigator) {
      if(cookies.lang) {
        setLang(cookies.lang)
      } else {
        const lg = window.navigator.language;
        if(lg.includes('en')) {
          setLang(SiteLangs.EN);
        } else if(lg.includes('es')) {
          setLang(SiteLangs.ES);
        } else if(lg.includes('zh')) {
          setLang(SiteLangs.ZH);
        } else if(lg.includes('pt')) {
          setLang(SiteLangs.PT);
        } else {
          setLang(SiteLangs.EN);
        }
      }
    }
  }, [cookies.lang])
  return (
    <I18NContext.Provider value={{lang, changeLang}}>
      <IntlProvider messages={messages} locale={lang} defaultLocale="en">
        {children}
      </IntlProvider>
    </I18NContext.Provider>
  );
}

export default I18NProvider;